import { Component, inject, computed } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CrntIcon } from '@crnt/web-angular';
import { TranslationService } from '../../services/translation.service';

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [CommonModule, CrntIcon],
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss',
})
export class HeaderComponent {
  readonly translationService = inject(TranslationService);

  readonly brandName = computed(() => this.translationService.t().brandName);
  readonly mijnText = computed(() => this.translationService.t().mijnText);
}
